export { default } from './TeamChatFileMessage';
